<template>
  <dialog id="confirm_upload_version" class="modal">
    <div class="modal-box">
      <h3 class="mb-4 text-lg font-bold">Xác nhận tải lên</h3>

      <div class="py-2">
        <div class="font-medium">Tệp</div>
        <div>{{ props.file ? props.file.name : "" }}</div>
      </div>

      <div class="py-2">
        <div class="font-medium">
          Phiên bản <span class="text-red-500">*</span>
        </div>
        <input
          class="input w-full text-base"
          v-model="create_version_store.version"
        />
      </div>

      <div class="py-2">
        <div class="font-medium">Mô tả</div>
        <textarea
          class="textarea w-full text-base"
          rows="4"
          v-model="create_version_store.description"
        ></textarea>
      </div>

      <div class="py-2">
        <div class="font-medium">Kích thước</div>
        <div>
          {{ prettyBytes(props.file ? props.file.size : 0) }}
        </div>
      </div>

      <div class="py-2">
        <div class="font-medium">Loại</div>
        <div>
          <select class="select w-full" v-model="uploadType">
            <option
              v-for="t in typeOptions"
              :key="t.be_mapping"
              :value="t.be_mapping"
            >
              {{ t.value }}
            </option>
          </select>
        </div>
      </div>

      <div class="py-2" v-if="create_version_store.loading">
        <div class="mb-1 flex justify-between">
          <span class="text-sm font-medium">Đang tải lên</span>
          <span class="text-sm font-medium"
            >{{ create_version_store.progress }}%</span
          >
        </div>
        <progress
          class="progress progress-primary w-full"
          :value="create_version_store.progress"
          max="100"
        ></progress>
      </div>

      <div class="modal-action">
        <form method="dialog" class="flex gap-2">
          <button class="btn" value="cancel">Hủy</button>
        </form>
        <button
          class="btn btn-primary min-w-28"
          :disabled="create_version_store.is_confirm_disabled"
          @click="handle_confirm"
        >
          <span v-if="create_version_store.loading">
            <Loading />
          </span>
          <span v-else> Xác nhận </span>
        </button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import prettyBytes from "pretty-bytes";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { tabs } from ".";
import Loading from "../LoadingTemplate.vue";
import { use_create_version } from "./useCreateVersion";

const props = defineProps<{
  file?: File;
}>();

const create_version_store = use_create_version();

// ponytail: options derive from the existing tabs array — add a tab in
// index.ts and upload gains its option for free. A chip covering several
// backend types (Kill AV) supplies its own upload_types list.
const typeOptions = tabs.flatMap((t) =>
  t.upload_types ?? (t.be_mapping ? [{ value: t.value, be_mapping: t.be_mapping }] : []),
);
const uploadType = ref<string>(typeOptions[0]?.be_mapping ?? "");

const handle_confirm = async () => {
  if (!props.file) return;

  try {
    await create_version_store.upload_version(
      props.file,
      create_version_store.version,
      create_version_store.description,
      uploadType.value,
    );
    const dialog = document.getElementById(
      "confirm_upload_version",
    ) as HTMLDialogElement;
    dialog.close();
  } catch (error) {
    console.error(error);
    toast.error("Đã xảy ra lỗi khi tải lên phiên bản.");
  }
};
</script>
